import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
    static targets = ['externalData', 'customerID', 'conversionActionID', 'conversionActionOrigin']
    static values = {
        conversionActionData: Object,
    }

    declare readonly externalDataTarget: HTMLInputElement
    declare readonly customerIDTarget: HTMLInputElement
    declare readonly conversionActionIDTarget: HTMLInputElement
    declare readonly conversionActionOriginTarget: HTMLInputElement
    declare readonly conversionActionDataValue: Object

    connect() {
        // NOTE:
        // Doing it like this because:
        // 1. Adding a new Stimulus controller and attaching it to the frame will require us
        //    to add the data-controller attribute in a file that's higher up in the abstraction
        //    than it should be.  This will result in forcing us to implement Stimulus controllers
        //    for each and every action, which is not what we want or need.
        // 2. Adding the form as a target of this controller is not possible, since to target it, we
        //    would have to add the notation to a file taht's higher up in the abstraction and will
        //    cause it to be coupled with the html.erb partials that it renders
        const form = this.element.closest('form')
        form?.addEventListener('submit', () => window.callpixels.utils.showLoading())
    }

    conversionActionIDTargetConnected() {
        window.callpixels.utils.hideLoading()
    }

    customer_id_change() {
        const turboFrame = this.externalDataTarget.closest('turbo-frame') as TurboFrameElement
        const url = new URL(turboFrame.src)
        const customerID = this.customerIDTarget.value as string
        const conversionActionID = this.conversionActionIDTarget.value as string

        // NOTE:
        // This is required because when we refresh the turbo frame we have to keep the user's
        // previously selected campaign ids otherwise they get lost upon refreshing the frame.
        //
        // Selecting it like this instead of with a target because this field is not nested in the
        // element which is the root element that this controller is attached to and I don't want to
        // propagate usage of this controller to other elements outside of the
        // /_upload_call_conversion_form.html.erb view because this is a better separation of
        // concerns.
        const campaignIDsSelect = document.querySelector(
            "select[name='integration_action[campaign_ids][]']",
        ) as HTMLSelectElement
        const campaignIDs = Array.prototype.slice
            .call(campaignIDsSelect.selectedOptions)
            .map((opt) => opt.value)
            .join(',')

        // NOTE:
        // This is required because when we refresh the turbo frame we have to keep the users choice
        // of whether it's global or not otherwise they get lost upon refreshing the frame.
        //
        // Selecting it like this instead of with a target because this field is not nested in the
        // element which is the root element that this controller is attached to and I don't want to
        // propagate usage of this controller to other elements outside of the
        // /_upload_call_conversion_form.html.erb view because this is a better separation of
        // concerns.
        const globallyEnabled = String(
            (
                document.querySelector(
                    "input[name='integration_action[globally_enabled]'][type='checkbox']",
                ) as HTMLInputElement
            ).checked,
        )

        url.searchParams.set('customer_id', customerID)
        url.searchParams.set('conversion_action_id', conversionActionID)
        url.searchParams.set('globally_enabled', globallyEnabled)
        url.searchParams.set('campaign_ids', campaignIDs)

        turboFrame.src = url.href

        window.callpixels.utils.showLoading()
    }

    conversion_action_id_change() {
        const turboFrame = this.externalDataTarget.closest('turbo-frame') as TurboFrameElement
        const url = new URL(turboFrame.src)
        const conversionActionID = this.conversionActionIDTarget.value as string

        this.conversionActionOriginTarget.value =
            this.conversionActionDataValue[conversionActionID].origin
        url.searchParams.set(
            'conversion_action_origin',
            this.conversionActionDataValue[conversionActionID].origin,
        )
    }
}
